<template>
  <div class="c-summary-view">
    <div class="c-summary-view_container c-view-container">
      <div class="c-view-container__inner">
        <div class="c-summary-view_content-col c-view-content-col">
          <div class="c-view-content-col__inner">
            <h2 class="c-summary-view__heading">Your savings</h2>
            <h2 class="c-summary-view__heading c-summary-view__heading--green">
              ${{ getAnnualSavingsTotal }}
            </h2>

            <div class="c-view-summary__save-area">
              <img
                class="c-view-summary__save-area-image"
                src="_resources/app/client/assets/images/answer-green.svg"
                alt="answer icon"
              />

              <div class="c-view-summary__save-area-text">
                <div v-html="Summary.SummaryViewEmailSaveForLater"></div>
                <EmailYourSavingsButton />
              </div>
            </div>
          </div>
        </div>

        <div class="c-summary-view_right-col">
          <div class="c-summary-view-receipt">
            <img
              class="c-summary-view-receipt__logo"
              src="_resources/app/client/assets/images/we-letters-logo.svg"
              alt="WE logo"
            />

            <div class="c-summary-view-receipt__items">
              <div
                class="c-summary-view-receipt__item-category"
                v-for="result in getAnnualSavingsResults"
                :key="result.category"
              >
                <div class="c-summary-view-receipt__item-category-heading">
                  {{ result.category }}
                </div>
                <div
                  class="c-summary-view-receipt__item-answer"
                  v-for="answer in result.answers"
                  :key="answer.QuestionSummaryText"
                >
                  <div class="c-summary-view-receipt__item-answer-heading">
                    {{ answer.QuestionSummaryText }}
                  </div>
                  <div
                    class="c-summary-view-receipt__item-answer-saving"
                    v-if="answer.SavingsAmountMultiplierApplied != null"
                  >
                    ${{ answer.SavingsAmountMultiplierApplied }} p/year
                  </div>
                </div>
              </div>
            </div>

            <div class="c-summary-view-receipt__total">
              <div class="c-summary-view-receipt__total-left">
                <p class="c-summary-view-receipt__total-heading">
                  **** Total ****
                </p>
                <p class="c-summary-view-receipt__total-subheading">
                  *Potential power savings
                </p>
              </div>
              <div class="c-summary-view-receipt__total-right">
                <p class="c-summary-view-receipt__total-amount">
                  ${{ getAnnualSavingsTotal }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-view-controls__wrapper">
      <div class="c-view-controls">
        <div class="c-view-controls__inner">
          <button class="u-calc-button u-calc-button--prev" @click="prev">
            <span></span>
            <p>Previous</p>
          </button>
          <button class="u-calc-button" @click="finish">
            <span></span>
            <p>Finish</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import EmailYourSavingsButton from "../EmailYourSavingsButton.vue";

export default {
  created() {},
  components: {
    EmailYourSavingsButton,
  },
  mounted() {},
  methods: {
    prev() {
      this.$store.dispatch("updateCurrentStepByDirection", "prev");
    },
    finish() {
      this.currentView = "FinishView";
    },
  },
  computed: {
    ...mapFields(["config.currentView", "viewContent.Summary"]),
    ...mapGetters(["getAnnualSavingsTotal", "getAnnualSavingsResults"]),
  },
};
</script>
<style lang="scss">
.c-summary-view_right-col {
  width: 48%;
  margin-left: 2%;
  max-height: 500px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 755px) {
    width: 100%;
    justify-content: center;
    margin-top: 50px;
  }
}

.c-summary-view_container {
  .c-view-container__inner {
    @media (max-width: 755px) {
      flex-direction: column;
    }
  }
}

.c-summary-view_content-col {
  @media (max-width: 755px) {
    width: 100% !important;
  }
}

.c-summary-view-receipt {
  position: relative;
  background-color: #ffffff;
  padding: 27px 28px;
  text-transform: uppercase;
  max-width: 325px;
  width: 100%;
  font-family: "Rajdhani", sans-serif;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
}

.c-summary-view-receipt__logo {
  position: absolute;
  top: 14px;
  right: 15px;
}

.c-summary-view-receipt__items {
}

.c-summary-view-receipt__item-category {
  display: flex;
  flex-direction: column;
  // background-color: pink;
  font-size: 16px !important;
}
.c-summary-view-receipt__item-category-heading {
  flex: 1;
  // background-color: yellow;
  font-weight: 800 !important;
}
.c-summary-view-receipt__item-answer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // background-color: green;
  margin-left: 15%;
}
.c-summary-view-receipt__item-answer-heading {
  // background-color: lavender;
  flex: 1;
}
.c-summary-view-receipt__item-answer-saving {
  // background-color: honeydew;
  text-transform: lowercase;
  flex: 90px 0 0;
}

.c-summary-view-receipt__total {
  border-top: 1px solid #000000;
  display: flex;
  margin-top: 35px;
  justify-content: space-between;
}

.c-summary-view-receipt__total-left {
}

.c-summary-view-receipt__total-right {
  display: flex;
  align-items: flex-end;
}

.c-summary-view-receipt__total-heading {
  font-size: 20px !important;
  line-height: 26px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-family: "Rajdhani", sans-serif !important;
}

.c-summary-view-receipt__total-subheading {
  font-size: 14px !important;
  line-height: 18px !important;
  font-weight: 700 !important;
  font-family: "Rajdhani", sans-serif !important;
  text-transform: lowercase !important;
}

.c-summary-view-receipt__total-amount {
  font-size: 20px !important;
  line-height: 26px !important;
  font-weight: 700 !important;
  font-family: "Rajdhani", sans-serif !important;
}

.c-summary-view__heading {
  font-family: "Nunito" !important;
  font-weight: 800 !important;
  font-size: 48px !important;
  line-height: 54px !important;
  margin: 0 !important;
  color: #ffffff;

  &--green {
    background-color: #04b776;
    display: inline-block;
    padding: 10px 16px;
    min-width: 180px;
  }

  @media (max-width: 755px) {
    font-size: 32px !important;
    line-height: 36px !important;
    margin-bottom: 12px;
  }
}

.c-view-summary__save-area {
  background-color: #ffffff;
  border-radius: 26px;
  padding: 13px 20px;
  padding-bottom: 20px;
  display: flex;
  margin-top: 34px;
  align-items: flex-start;

  @media (max-width: 755px) {
    width: 100%;
  }

  img {
    width: 45px;
    height: 45px;

    @media (max-width: 755px) {
      width: 35px;
      height: 35px;
    }
  }
}

.c-view-summary__save-area-text {
  margin-left: 12px;
}
</style>
